import React, {Component} from 'react';
import { connect } from '../../utils';
import ResponsiveImage from './ResponsiveImage';
import styled from 'styled-components';


class ImageTextView extends Component{
  renderText = (value) =>{
    return <div dangerouslySetInnerHTML={{__html:value}} />;
  }
  render(){
    const {id,layoutState} = this.props;
    const {containerPadding, backgroundImage, text } = layoutState.getItemJS(id).props.values;
    let srcMobile = backgroundImage.urlMobile || backgroundImage.url || "";
    let srcDesktop = backgroundImage.url || backgroundImage.urlMobile || "";

    return(
      <div style={{padding:containerPadding}}>
        <BoxImage>
          <ResponsiveImage srcDesktop={srcDesktop} srcMobile={srcMobile}  alt="Image Template" />
          <MiddleView>
            <MiddleText style={{padding:text.containerPadding,lineHeight:text.lineHeight, letterSpacing:text.letterSpacing, backgroundColor:text.backgroundColor}}>{this.renderText(text.value)}</MiddleText>
          </MiddleView>
        </BoxImage>

      </div>
    )
  }
}


const BoxImage = styled.div`
  position: relative;
  width: 100%;
`;
const MiddleView = styled.div`
  position: absolute;
  left: 50%; top: 50%; transform: translate(-50%,-50%);
  display: flex;
  flex:1;
  justify-content: center;
  flex-direction: column;
  width:100%;
  height:100%;
`;

const MiddleText = styled.div`
  align-items: center;
  justify-content: center;
`;

export default connect('layoutState')(ImageTextView);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/ImageTextView.js